
import { Component, Prop, Vue } from 'vue-property-decorator'
import ContentUnitBox from '@/components/molecules/ContentUnitBox.vue'

/**
 * 色付き：パネル枠内の項目ボックス
 */
@Component({
  components: {
    ContentUnitBox,
  },
})
export default class ColorContentUnitBox extends Vue {
  /** css色指定の変数（文字列）*/
  @Prop()
  private colorCode!: string

  /**
   * ボックスのカラータグの色指定
   *
   * @returns css色指定
   */
  private setStyle(): { [key: string]: string } {
    return {
      '--learning-progress-color': `var(${this.colorCode})`,
    }
  }

  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
